import React, { useState,useCallback } from 'react';
import { Button } from 'react-bootstrap';
import WorkPositionDatatable from '../../modules/user/WorkPositionDatatable';
import WorkPositionModal from '../../modules/user/WorkPositionModal';

const WorkPositionTab = (props) => {

    const [show , setShow]= useState( false );
    const [recordId, setRecordId ] = useState( "" );
   
  
    

    const handleCallback  = useCallback(
        (id) => {
            setRecordId(id);       
            setShow(true);   
        },
        [], 
      );

    const modalCallback = (isShow) => {             
        setShow(isShow);       
    }

    return (
       <> 
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>
            <WorkPositionDatatable                
                parentCallback={handleCallback}
                entityId={props.entityId}                 
                modalShow={show}           
            />          
            <Button
              //  bsStyle="primary"    
                className="ml-3 mt-3"
                onClick={() => handleCallback('')}
            >
            <i className="fas fa-plus"></i>
            </Button>
        </div>

        <WorkPositionModal
                modal={show}
                parentCallback={modalCallback}
                selectedRecord={recordId}
                entityId={props.entityId}            
            />
      </>
    );
};

export default WorkPositionTab;